import * as z from "zod/v4";

const competitorOption_ = z.object({
  id: z.string(),
  name: z.string(),
  website: z.string(),
});

const topicOption_ = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string().nullable(),
});

export const getAeoDashboardFilterOptions = {
  name: "getAeoDashboardFilterOptions" as const,
  input: z.object({}),
  output: z.object({
    competitors: z.array(competitorOption_),
    topics: z.array(topicOption_),
  }),
};
